import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppService } from '../../app.service';
import { environment } from '@environments/environment';

export abstract class BaseService {
  protected http = inject(HttpClient);
  protected appService = inject(AppService);
  protected apiUrl: string;

  constructor(apiPath: string) {
    this.apiUrl = `${environment.apiUrl}/${apiPath}`;
  }

  protected getHeaders(): HttpHeaders {
    const municipalityId = this.appService.municipalityId();
    if (!municipalityId) {
      throw new Error('Geen gemeente geselecteerd');
    }
    return new HttpHeaders().set('X-Municipality-Id', municipalityId);
  }

  protected getMunicipalityId(): string {
    const municipalityId = this.appService.municipalityId();
    if (!municipalityId) {
      throw new Error('Geen gemeente geselecteerd');
    }
    return municipalityId;
  }
}
